import { Link } from "react-router-dom";
import "./service.scss";
import Workshop from "../../Images/png/Workshop.png";
import Arrow from "../SVG/ArrowSvg";

const Services = () => {
  return (
    <section className="services">
      <div className="left">
        <p className="tag">diensten</p>
        <div className="img-container">
          <img src={Workshop} alt="Workshop" />
        </div>
      </div>
      <div className="text-container">
        <ul className="list">
          <li className="list-item">
            <Link to="training" className="">
              <Arrow className="hide" />
              <p className="nav-text">Boek een training</p>
            </Link>
            <p className="hide-text">
              Trainingen zoals "Interculturele communicatie" en "Omgaan met
              moeilijk gedrag" bieden inzicht in de mogelijkheden die
              communicatie en samenwerking bieden binnen een zakelijke of
              educatieve context.
            </p>
          </li>
          <li className="list-item">
            <Link to="coaching">
              <Arrow className="hide" />
              <p className="nav-text">Start een coachingstraject</p>
            </Link>
            <p className="hide-text">
              Binnen verschillende organisaties coach ik teams en individuele
              coachees op het gebied van persoonlijke ontwikkeling. Gelijkheid,
              praktische toepassing, concrete theorieën en humor staan altijd
              centraal.
            </p>
          </li>
          <li className="list-item">
            <Link to="writing">
              <Arrow className="hide" />
              <p className="nav-text">Boek een lezing</p>
            </Link>
            <p className="hide-text">
              Ik heb de boeken "Red mij niet" (2021) en "Anti-aanbakbrein"
              (2022) geschreven. In 2010 werd mijn methodologie voor primair
              onderwijs gepubliceerd, die zich richt op co-creatie, meervoudige
              intelligentie en leerstijlen. Ik heb ook geschreven voor
              NuZakelijk.nl en Viva.nl, onder andere.
            </p>
          </li>
        </ul>

        <p className="sub-text">
          Trainingen zoals "Interculturele communicatie" en "Omgaan met moeilijk
          gedrag" bieden inzicht in de mogelijkheden die communicatie en
          samenwerking bieden binnen een zakelijke of educatieve context.
        </p>

        <p></p>
      </div>
    </section>
  );
};

export default Services;
